<template>
  <div class="stat-courier-page">
    <v-container fluid>
      <stat-top-filter
        :days-count="30"
        :filial-default="globalFilialId"
        disable-filial-presets
        @applyFilter="fetchData"
      />

      <indicators-list
        v-if="Object.keys(indicators).length"
        class="mb-5"
        :indicators="indicators"
        :loading="indicatorsLoading"
      />

      <chart-container
        class="mb-5"
        :loading="ratingsLoading"
        :no-data="!ratings.length"
      >
        <template #chart>
          <ratings-chart
            :items="ratings"
            :time-unit="chartTimeUnit"
          />
        </template>
      </chart-container>

      <v-row>
        <v-col md="6" cols="12">
          <chart-container
            style="height: 100%"
            :loading="reasonsStatLoading"
            :no-data="!reasons.length"
          >
            <template #chart>
              <reviews-pie-chart
                title="Причины низких оценок"
                :items="reasons"
                :colors="['#FF9D00', '#EB5388', '#4DAF4A', '#11A9FF', '#A5A5A5', '#000000']"
                legend-container-id="reasons"
              />
            </template>
          </chart-container>
        </v-col>
        <v-col md="6" cols="12">
          <chart-container
            style="height: 100%"
            :loading="usefulActionsStatLoading"
            :no-data="!usefulActions.length"
          >
            <template #chart>
              <reviews-pie-chart
                title="Полезные действия"
                :items="usefulActions"
                :colors="['#FFC800', '#EB5388', '#000000', '#11A9FF', '#A5A5A5', '#4DAF4A']"
                legend-container-id="useful-actions"
              />
            </template>
          </chart-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import StatTopFilter from '@/components/stat/StatTopFilter.vue'
  import RatingsChart from '@/components/stat/service/RatingsChart.vue'
  import ReviewsPieChart from '@/components/stat/service/ReviewsPieChart.vue'
  import ReviewsIndicatorsList from '@/components/stat/service/ReviewsIndicatorsList.vue'
  import { mapGetters } from 'vuex'
  import reviewsStatisticsApi from '@/api/statistics/reviews'
  import { differenceInMonths, differenceInYears } from 'date-fns'
  import ChartContainer from '@/components/stat/ChartContainer.vue'

  export default {
    name: 'RatingStatistics',
    components: { ChartContainer, StatTopFilter, RatingsChart, ReviewsPieChart, IndicatorsList: ReviewsIndicatorsList },
    data () {
      return {
        showDaysCount: 30,
        ratingsLoading: false,
        indicatorsLoading: false,
        reasonsStatLoading: false,
        usefulActionsStatLoading: false,
        indicators: {},
        ratings: [],
        reasons: [],
        usefulActions: [],
        startDate: null,
        endDate: null,
        chartTimeUnit: 'day',
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
    },
    methods: {
      calcChartTimeUnit (from, to) {
        if (!from || !to) {
          return 'day'
        }

        const startDate = new Date(from)
        const endDate = new Date(to)

        if (Math.abs(differenceInYears(endDate, startDate)) >= 1) {
          return 'month'
        }

        if (Math.abs(differenceInMonths(endDate, startDate)) >= 2) {
          return 'week'
        }

        return 'day'
      },
      fetchData (filter) {
        Promise.all([
          this.fetchIndicators(filter),
          this.fetchRatings(filter),
          this.fetchReasonsStat(filter),
          this.fetchUsefulActionsStat(filter),
        ])
          .then(() => {
            this.chartTimeUnit = this.calcChartTimeUnit(filter.from, filter.to)
          })
      },
      fetchRatings (filter) {
        this.ratingsLoading = true

        return reviewsStatisticsApi.fetchRatingsStatistics(filter.filialId, filter.from, filter.to)
          .then(response => {
            this.ratings = response.items
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.ratingsLoading = false
          })
      },
      fetchIndicators (filter) {
        this.indicatorsLoading = true

        return reviewsStatisticsApi.fetchIndicators(filter.filialId, filter.from, filter.to)
          .then(response => {
            this.indicators = response
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.indicatorsLoading = false
          })
      },
      fetchReasonsStat (filter) {
        this.reasonsStatLoading = true

        return reviewsStatisticsApi.fetchReasonsStatistics(filter.filialId, filter.from, filter.to)
          .then(response => {
            this.reasons = response.items
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.reasonsStatLoading = false
          })
      },
      fetchUsefulActionsStat (filter) {
        this.usefulActionsStatLoading = true

        return reviewsStatisticsApi.fetchUsefulActionsStatistics(filter.filialId, filter.from, filter.to)
          .then(response => {
            this.usefulActions = response.items
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.usefulActionsStatLoading = false
          })
      },
    },
  }
</script>

<style lang="less" scoped>
@import '@/assets/styles/statistic.less';
</style>
